import {
  Avatar,
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ContentPage from "../Components/ContentPage";
import HomeIcon from "@mui/icons-material/Home";
import { useFormik } from "formik";
import * as Yup from "yup";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import authService from "../Services/auth.service";
import { usersUpdate } from "../store/Slice/usersSlice";
import { useDispatch } from "react-redux";

export default function DefaultUser() {
  const user = authService.auth();
  const dispatch = useDispatch();

  const [updateUser, setUpdate] = useState(false);

  useEffect(() => {
    if (user.idcard) {
      setUpdate(true);
    }
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: user.id || "",
      nameprefix: user.nameprefix || "",
      fname: user.fname || "",
      lname: user.lname || "",
      idcard: user.idcard || "",
      phone: user.phone || "",
      email: user.email || "",
      addrpart: user.addrpart || "",
      tmbpart: user.tmbpart || "",
      amppart: user.amppart || "",
      chwpart: user.chwpart || "",
      zipcode: user.zipcode || "",
    },
    validationSchema: Yup.object().shape({
      nameprefix: Yup.string().required("ระบุคำน้ำหน้า"),
      fname: Yup.string().required("ระบุชื่อ"),
      lname: Yup.string().required("ระบุนามสกุล"),
      idcard: Yup.string().required("ระบุ ID Card"),
    }),
    onSubmit: (values) => {
      console.log(values);
      //   if (values.id) {
      dispatch(usersUpdate(values)).then(() => {
        setUpdate(true);
      });
      //   } else {
      //     dispatch(usersCreate(values)).then(() => {
      //       dispatch(list());
      //       handleClose();
      //     });
      //   }
    },
  });
  console.log(formik.errors);
  return (
    <Container maxWidth={"lg"}>
      <ContentPage
        title="ลงทะเบียนผ่าน LINE"
        TitlePageMenulist={[
          {
            label: "หน้าแรก",
            href: "#",
            icon: <HomeIcon fontSize="small" />,
          },
        ]}
      >
        {!updateUser ? (
          <Paper
            elevation={0}
            sx={{ p: 1 }}
            component={"form"}
            onSubmit={formik.handleSubmit}
          >
            <Grid
              container
              direction={"row"}
              justifyContent={"flex-start"}
              spacing={2}
            >
              <Grid item xs={12} md={12}>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  ข้อมูล
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="nameprefix"
                  name="nameprefix"
                  value={formik.values.nameprefix}
                  label="คำนำหน้า"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.nameprefix)}
                  helperText={formik.errors.nameprefix}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="fname"
                  name="fname"
                  value={formik.values.fname}
                  label="ชื่อ"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.fname)}
                  helperText={formik.errors.fname}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="lname"
                  name="lname"
                  value={formik.values.lname}
                  label="นามสกุล"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.lname)}
                  helperText={formik.errors.lname}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="idcard"
                  name="idcard"
                  value={formik.values.idcard}
                  label="เลขบัตรประชาชน"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.idcard)}
                  helperText={formik.errors.idcard}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="phone"
                  name="phone"
                  value={formik.values.phone}
                  label="เบอร์ติดต่อ"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="email"
                  name="email"
                  value={formik.values.email}
                  label="E-Mail"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  ที่อยู่
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="addrpart"
                  name="addrpart"
                  value={formik.values.addrpart}
                  label="ที่อยู่"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="tmbpart"
                  name="tmbpart"
                  value={formik.values.tmbpart}
                  label="แขวง/ตำบล"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="amppart"
                  name="amppart"
                  value={formik.values.amppart}
                  label="เขต/อำเภอ"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="chwpart"
                  name="chwpart"
                  value={formik.values.chwpart}
                  label="จังหวัด"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="zipcode"
                  name="zipcode"
                  value={formik.values.zipcode}
                  label="เลขไปรษณี"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  variant="contained"
                  type="submit"
                  autoFocus
                  startIcon={<SaveAltIcon />}
                >
                  อัพเดท
                </Button>
              </Grid>
            </Grid>
          </Paper>
        ) : (
          <Paper
            elevation={0}
            sx={{ p: 2, display: "flex", justifyContent: "center" }}
          >
            <Stack
              direction={"column"}
              justifyContent={"center"}
              spacing={2}
              alignItems={"center"}
            >
              <Avatar
                variant="rounded"
                src={process.env.PUBLIC_URL + "/success.png"}
                sx={{
                  width: 150,
                  height: 150,
                }}
              />
              <Typography variant="h6">
                รอผู้ดูแลระบบอนุมัติการใช้งาน
              </Typography>
            </Stack>
          </Paper>
        )}
      </ContentPage>
    </Container>
  );
}
